import { render, staticRenderFns } from "./ExpenseProjectionTable.vue?vue&type=template&id=a3530000&scoped=true&"
import script from "./ExpenseProjectionTable.vue?vue&type=script&lang=js&"
export * from "./ExpenseProjectionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3530000",
  null
  
)

export default component.exports